import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image'
import Col from 'react-bootstrap/Col';
import { Fancybox } from "@fancyapps/ui"
 

function HelpComponent() {
    
      return (
        <Container fluid id="helpPage">
          <Row className="p-2 m-2">
            <h2>Инструкции по сервису</h2>

            <p>Сервис "служба механика", 
              состоит из нескольких независимых разделов:</p>
              <ul>
                <li>Журнал ремонтов</li>
                <li>Журнал планирования ремонтов</li>
                <li>Журнал заявок снабжение</li>
              </ul>
            



            <h3>Журнал ремонтов</h3>
            <p>Здесь реализуется функционал полноценного журнала ремонтов оборудования. 
              Основной функционал:</p>
              <ul>
                <li>Записи о ремонтах. Дата-время начала и окончания.</li>
                <li>Строгий выбор из списка оборудования.</li>
                <li>Присваивание категории работ (обслуживание, ремонт...)</li>
                <li>Записи об установленных расходных материалах, затратах</li>
                <li>Поиск по периоду работ</li>
                <li>Поиск по конкретному оборудованию. и (или) по описанию.</li>
              </ul>
            <p>
              Для ввода записи, требуется зайти в меню "ввод данных" и нажать "добавить работы".
              Откроется модальное окно (карточка), для заполнения. 
              Заполнить поля. Обязательное поле оборудование, и описание работ. Остальные поля необязательные.
              Поля дата работ заполняются автоматически, но можно их поменять. 
              Нажатие на кнопку создать - записывает работы в базу данных. и оно появляется в таблице. 


            </p>
            <p>Записи нельзя удалить. Однако допускается редактировать записи. Для этого в основной таблице нужно нажать на кнопку в графе #.

            </p>
            <p>
              Таблица выполненных работы, может быть отфильтрована по датам для удобства.
            </p>
           
           <h3>Журнал планирования ремонтов</h3>
           <p>
            Это отдельный журнал, помогающий планировать ремонты, и учитывать неисправности оборудования.
            Здесь записи также добавляются с помощнью кнопки "Добавить задачу".

           </p>
           <p>При заполнении новой задачи, минимально требуется указать наименование оборудования, и описание работ. 
            Остальные поля не обязательно. 
            <ul>Поля:</ul>
            <li><strong>Статус задачи </strong> - для указание того в каком статусе задача (выполнена, в работе, активная, закрытая).</li>
            <li><strong>Трудозатраты</strong> - оценка времени для планирования. </li>
            <li><strong>Тэг</strong>-  для удобства групировки (конвейера, дробилки, сварка и т.п) - на усмотрение механика.</li>


            <li><strong>Приоритет задачи</strong> - заполняется произвольно.</li>
            <li><strong>Важность задачи</strong> -срочно, важно и т.п.</li>
            <li><strong>Комментарии</strong> - дополнительные данные - что требуется, и прочие записи.</li> 
            
           </p>

           <p>
            В основной таблице "План ремонтов" возможно выполнять поиск, фильтрацию и группировки записей по различным параметрам.
            Записи удалить нельзя, записи со статусом "завершено и отменено", автоматически скрываются, однако доступны при необходимости. 
            Подсветка записей выполняется по выбраной важности задачи.

           </p>



           <h3>Заявки снабжение</h3>
           <p>Также независимый журнал, для учета заявок участка ремонта оборудования.</p>
            <p>Для создания новой заявки, достаточно нажать кнопку "создать заявку". Ввести описание заявки и нажать "Создать"</p>
            <p>поля статус заявки, категория, приоритет заполняются исходя из логики, для упрощенного поиска информации. </p>
            <p>Поле примечание для дополнительных данных. </p>


            <p>При создании заявки в таблице создаются поля - дата, Автор, и Автор изменения.</p>
            <p>поле автор последних изменений служит для отслеживание 
              последних изменений. например, ст.механик написал согласовано, значит снабженец заказывает
               позицию и т.д.
              Заявки как и записи в журнале ремонта нельзя удалить, однако можно указать статус "выполнено", "отменено" для скрытия.
               
                </p>







          </Row>

            
         


 
        </Container>
      );
    
};
export default HelpComponent;


